<template>
  <button
    @click="copyToClipboard()"
    class="c-clipboard">
    <Icon icon="fa-regular:copy" class="fs-18" />
  </button>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    certificate: String,
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(`${process.env.VUE_APP_SITE}/panel/certificados/${this.certificate}`);

        Vue.$toast.open({
          message: 'Enlace copiado exitosamente!',
          type: 'success',
          position: 'bottom-left',
        });
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    },
  },
};
</script>
